import { render, staticRenderFns } from "./UserDepartments.vue?vue&type=template&id=59de46ae&scoped=true"
import script from "./UserDepartments.vue?vue&type=script&lang=js"
export * from "./UserDepartments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59de46ae",
  null
  
)

export default component.exports